import { Component, ViewEncapsulation } from '@angular/core';
import { CheckinCheckoutReportService } from './checkin-checkout-report.service';
import { firstValueFrom } from "rxjs";
import { TranslateService } from '@ngx-translate/core';
import { commonFunctionService } from '../utils/commonFunctions';
import moment from 'moment';

declare var $: any;
declare var customToastr: any;

@Component({
  selector: 'app-checkin-checkout-report',
  providers: [CheckinCheckoutReportService],
  templateUrl: './checkin-checkout-report.component.html',
  styleUrls: [
    './checkin-checkout-report.component.css',
    './../category-wise-report/category-wise-report.component.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../_crop/css/style.css',
    './../../_crop/css/style-example.css',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CheckinCheckoutReportComponent {
  wingListData: any = [];
  classStandardData: any = [];
  classSectionData: any = [];
  selectedWings: any = [];
  selectedClass: any = null;
  selectedSection: any = null;
  selectedClassList: any[] = [];
  selectedSectionList: any[] = [];
  selectedStudentSearch: string = '';
  selectedEntryStatus: string = 'All';
  isExpanded: boolean = false;
  appliedClassStandard: any = 'All';
  appliedClassId: any = 'All';
  openOptionForSectionSelection: boolean = false;
  studentList: any[] = [];
  filteredStudentList: any[] = [];
  selectedStudentList: number[] = [];
  selectedExportColumns: number[] = [];
  selectedStudentId: number | null = null;
  customStudentLabel: string = 'None';
  today: Date = new Date();

  academicStartDate: any = null;
  stringsData: any;
  columnIndex: number | null = null;
  openOptionForClassSelection: boolean = false;

  isStatsLoading: boolean = false;
  stats: any = [];
  appliedWing: any = 'All';
  appliedClass: any = 'All';
  appliedSection: any = 'All';
  appliedStudentSearch: string = '';
  appliedEntryStatus: string = 'All';
  appliedDate: any = null;
  statsLoaderArray: any[] = [];
  rows: any[] = [];
  cols: any[] = [];

  isReportLoading: boolean = false;
  loadingWingData: boolean = false;
  loadingStudentData: boolean = false;
  loadingClassData: boolean = false;
  loadingSectionData: boolean = false;
  openOptionForWingSelection: boolean = false;
  fetchingClassData: boolean = false;
  fetchingSectionData: boolean = false;
  isFilterOpen: boolean = false;
  isFilterApplied: boolean = false;
  isStatsExpanded: boolean = false;
  panelVisible: boolean = false;
  isExportingReport: boolean = false;
  statsMap: any = {};

  startDate: string = this.getTodayDate();
  selected: any;
  locale: any = { format: 'DD-MM-YYYY' };
  ranges: any = {};
  selectedAcademicYear: any = null;
  academicId:number|string;
  appliedStudentList: number[] = [];

  customWingLabel: string = 'None';
  customClassLabel: string = 'None';
  customSectionLabel: string = 'None';

  totalRecords: number = 0;
  totalStudents: number = 0;
  maxPageNumber: number = 0;
  reportColumns: any[] = [];
  reportData: any[] = [];
  pageNumber: number = 1;
  pageLimit: number = 10;
  constructor(
    private checkinCheckoutService: CheckinCheckoutReportService, private translate: TranslateService,private commonFunctionService: commonFunctionService
  ) {
    this.getWingListData();
     this.academicStartDate = localStorage.getItem("academicStartDate");
    this.selectedAcademicYear = this.academicStartDate ? new Date(this.academicStartDate) : new Date();
   const schoolData = localStorage.getItem('schoolAllInfo');
   const schoolInfo = schoolData ? JSON.parse(schoolData) : null;
   this.academicId = schoolInfo?.currentAcademicId;
  }

// Returns today's date
  getTodayDate(): string {
  return moment().format('DD-MM-YYYY');
}

  //reset all filters to default values
  async resetFilter() {
    this.selectedWings = [...this.wingListData];
    this.selectedClassList = [];
    this.selectedSectionList = [];
    this.selectedStudentList = [];
    this.filteredStudentList = [];
    this.selectedStudentSearch = '';
    this.selectedEntryStatus = 'All';
    const today = new Date();
    this.selected = today;
    this.startDate = this.getTodayDate();
    this.isFilterApplied = false;

    this.appliedWing = 'All';
    this.appliedClass = 'All';
    this.appliedSection = 'All';
    this.appliedStudentSearch = '';
    this.appliedEntryStatus = 'All';

    this.customWingLabel = 'All';
    this.customClassLabel = 'All';
    this.customSectionLabel = 'All';
    this.customStudentLabel = 'All';
    this.pageNumber = 1;
    this.pageLimit = 10;
    await this.getClassStandardList("All");
    await this.getClassSectionList("All", "All");
    this.applyFilter();
  }

  // apply filters to the report and stats
  applyFilter() {
    this.isFilterApplied = true;
     if (this.selectedWings.length === 0) {
    this.selectedWings = [...this.wingListData];
  }
  if (this.selectedClassList.length === 0) {
    this.selectedClassList = [...this.classStandardData];
  }
  if (this.selectedSectionList.length === 0) {
    this.selectedSectionList = [...this.classSectionData];
  }
    if (this.selectedWings.length === 0 || this.selectedWings.length === this.wingListData.length) {
    this.appliedWing = 'All';
  } else {
    this.appliedWing = [...this.selectedWings];
  }
    if (this.selectedClassList.length === 0 || this.selectedClassList.length === this.classStandardData.length) {
    this.appliedClass = 'All';
  } else {
    this.appliedClass = [...this.selectedClassList];
  }
     if (this.selectedSectionList.length === 0 || this.selectedSectionList.length === this.classSectionData.length) {
    this.appliedSection = 'All';
  } else {
    this.appliedSection = [...this.selectedSectionList];
  }
  this.appliedStudentList = [...this.selectedStudentList];
    this.appliedStudentSearch = this.selectedStudentSearch;
    this.appliedEntryStatus = this.selectedEntryStatus;
    this.appliedDate= this.startDate;
    this.getCheckinCheckoutStats();
    this.pageNumber = 1;
    this.getCheckinCheckoutReportData(this.pageNumber, this.pageLimit);
  }

  // On component initialization
  ngOnInit() {
    const today = new Date();
    this.selected = today;
    this.startDate = this.formatUiDate(today);
    this.appliedDate = this.startDate;
    this.getCheckinCheckoutStats();
    this.getCheckinCheckoutReportData(this.pageNumber, this.pageLimit);
    this.statsLoaderArray = this.commonFunctionService.generateDummyArray(4);
    this.rows = this.commonFunctionService.generateDummyArray(10); 
    this.cols = this.commonFunctionService.generateDummyArray(6);  
  }

  // Toggles visibility of the filter panel.
  expandView() {
    this.isFilterOpen = !this.isFilterOpen;
  }

  // Updates wing dropdown label based on current selection count.
  updateWingLabel() {
    if (this.selectedWings.length === 0) {
      this.customWingLabel = 'All';
    } else if (this.selectedWings.length === this.wingListData.length) {
      this.customWingLabel = 'All';
    } else {
      this.customWingLabel = `${this.selectedWings.length} selected`;
    }
  }

  // Updates class dropdown label based on current selection count.
  updateClassLabel() {
    if (this.selectedClassList.length === 0) {
      this.customClassLabel = 'All';
    } else if (this.selectedClassList.length === this.classStandardData.length) {
      this.customClassLabel = 'All';
    } else {
      this.customClassLabel = `${this.selectedClassList.length} selected`;
    }
  }

  // updates section dropdown label based on current selection count.
  updateSectionLabel() {
    if (this.selectedSectionList.length === 0) {
      this.customSectionLabel = 'All';
    } else if (this.selectedSectionList.length === this.classSectionData.length) {
      this.customSectionLabel = 'All';
    } else {
      this.customSectionLabel = `${this.selectedSectionList.length} selected`;
    }
  }

// expansion of stats panel
  toggleStatsExpansion() {
    this.isStatsExpanded = !this.isStatsExpanded;
  }

  // Formats a Date into YYYY-MM-DD string for UI and backend.
  formatUiDate(date: Date): string {
  return moment(date).format('YYYY-MM-DD');
}

  // Handles date selection from the date picker.
  dateSelected(event: any) {
    this.selected = event;   
    this.startDate = this.formatUiDate(event); 
  }

  // Formats a Date into YYYY-MM-DD string for API.
  formatToApiDate(date: Date): string {
  if (!date) return '';
  return moment(date).format('YYYY-MM-DD');
}

  // Updates student dropdown label based on current selection count.
  updateStudentLabel() {
    if (this.selectedStudentList.length === 0) {
      this.customStudentLabel = 'None';
    } else if (this.selectedStudentList.length === this.studentList.length) {
      this.customStudentLabel = 'All';
    } else {
      this.customStudentLabel = `${this.selectedStudentList.length} selected`;
    }
  }

  // Collapses the table column options
  collapseColumnOption(event: Event) {
    this.columnIndex = null;
  }

  // Returns 'All' when selection is empty or full, otherwise array of ids from selected items.
  getAllOrIds(selected: any[], all: any[], idKey: string): any {
    if ((!selected || selected.length === 0 || selected.length === all.length)
    ) {
      return 'All';
    }
    return selected.map(x => x[idKey]);
  }

  // Returns 'All' when selection is empty or full, otherwise array of ids from selected items.
  getStudentIds(selected: number[], all: any[]): any {
    if (!selected || selected.length === 0 || selected.length === all.length) {
      return 'All';
    }
    return selected;
  }

  // Handles student selection change.
  onStudentChange(event: any) {
    this.selectedStudentId = event.value.length > 0 ? event.value[0] : null;
    this.filteredStudentList = [...this.studentList];
  }

  // Closes the wing selection options.
  closeWingOption() {
    this.openOptionForWingSelection = false;
  }

  // Returns entry status filter value based on selection.
  getEntryStatusFilter(): string[] | string {
    const status = this.selectedEntryStatus;
    if (!status || status === 'All') {
      return 'All';
    }
    return [status];
  }

  // Handles entry status change.
  onEntryStatusChange(event: any) {
    this.selectedEntryStatus = event.value;
  }

  // Returns entry status options.
  entryStatusOptions = [
    { label: 'All', value: 'All' },
    { label: 'Only checked in', value: 'ONLY_CHECKED_IN' },
    { label: 'Only checked out', value: 'ONLY_CHECKED_OUT' },
    { label: 'Not checked in', value: 'NOT_CHECKED_IN' }
  ];

  // Returns entry status label based on value.
  getEntryStatusLabel(value: string): string {
    const option = this.entryStatusOptions.find(o => o.value === value);
    return option ? option.label : value;
  }

  // Handles page change event for pagination.
  onPageChange(event: any) {
  this.pageNumber = event.page + 1; 
  this.pageLimit = event.rows;
  this.getCheckinCheckoutReportData(this.pageNumber, this.pageLimit);
}

// Updates table column based on user selection.
  updateTableColumn(currentSlug: string, newSlug: string, event: Event) {
    if (currentSlug === newSlug) {
      return;
    }
    const currentSlugDataIndex = this.reportColumns.findIndex(
      (item) => item.slug === currentSlug
    );
    const newSlugDataIndex = this.reportColumns.findIndex(
      (item) => item.slug === newSlug
    );
    if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
      const currentData = this.reportColumns[currentSlugDataIndex];
      const newData = this.reportColumns[newSlugDataIndex];
      const currentInfo = { ...currentData, isDefault: 0 };
      const newInfo = { ...newData, isDefault: 1 };
      this.reportColumns[currentSlugDataIndex] = newInfo;
      this.reportColumns[newSlugDataIndex] = currentInfo;
    }
    setTimeout(() => {
      this.columnIndex = null;
    }, 0);
  }

  // Expands the table column options
  expandColumnOption(colId: number, event?: Event) {
    if (this.columnIndex === colId) {
      this.columnIndex = null;
    } else {
      this.columnIndex = colId;
    }
  }

  // Closes the table column options
  closeDropdown() {
    this.columnIndex = null;
  }

  // Handles page limit change for pagination.
  changePageLimit() {
  this.pageNumber = 1;
  this.getCheckinCheckoutReportData(this.pageNumber, this.pageLimit);
}

// Handles wing selection change.
  onWingChange(event: any) {
    this.updateWingLabel();
    let selectedWingIds: any;
    if (!this.selectedWings || this.selectedWings.length === 0) {
      selectedWingIds = 'All';
    } else if (this.selectedWings.length === this.wingListData.length) {
      selectedWingIds = 'All';
    }
    else {
      selectedWingIds = this.selectedWings.map((w: any) => w.categoryId || w.id);
    }
    this.selectedClassList = [];
    this.selectedSectionList = [];
    this.customClassLabel = 'None';
    this.customSectionLabel = 'None';
    this.getClassStandardList(selectedWingIds);
  }

  // Handles class selection change.
  onClassChange(event: any) {
    this.updateClassLabel();
    this.updateWingCheckStatus();
    this.updateSectionCheckStatus();
    let selectedWingIds;
    if (!this.selectedWings || this.selectedWings.length === 0) {
      selectedWingIds = 'All';
    } else if (this.selectedWings.length === this.wingListData.length) {
      selectedWingIds = 'All';
    } else {
      selectedWingIds = this.selectedWings.map((w: any) => w.categoryId);
    }
    let selectedClassIds;
    if (!this.selectedClassList || this.selectedClassList.length === 0) {
      selectedClassIds = 'All';
    } else if (this.selectedClassList.length === this.classStandardData.length) {
      selectedClassIds = 'All';
    } else {
      selectedClassIds = this.selectedClassList.map((c: any) => c.pkClassStandardsId);
    }
    this.selectedSectionList = [];
    this.customSectionLabel = 'None';
    this.getClassSectionList(selectedClassIds, selectedWingIds);
  }

  // Handles section selection change.
 onSectionChange(event: any) {
  this.updateSectionLabel();
  if (this.selectedSectionList.length > 0) {
    const classIds = new Set();
    const wingIds = new Set();
    this.selectedSectionList.forEach((section: any) => {
      classIds.add(section.pkClassStandardsId);
      wingIds.add(section.categoryId);
    });
    this.selectedClassList = this.classStandardData.filter((cls: any) => 
      classIds.has(cls.pkClassStandardsId)
    );
    this.selectedWings = this.wingListData.filter((wing: any) => 
      wingIds.has(wing.categoryId)
    );
    this.updateClassStatusCheckStatus(); 
  }
  this.fetchStudentList();
}

// Fetches wing list data from the API's.
  async getWingListData() {
    this.loadingWingData = true;
    try {
      const response: any = await firstValueFrom(this.checkinCheckoutService.getWingData());
      if (response.status && response.body) {
        this.wingListData = (response.body.classCategoryListDetails || []).map((w:any)=>({...w, isChecked: true}));
        this.selectedWings = [...this.wingListData];
        this.updateWingLabel();
        const wingIds = this.wingListData.map((w: any) => w.categoryId);
        await this.getClassStandardList(wingIds);
      } else {
        this.wingListData = [];
        this.selectedWings = [];
        this.updateWingLabel();
      }
    } catch (error) {
      this.wingListData = [];
      this.selectedWings = [];
      this.updateWingLabel();
    } finally {
      this.loadingWingData = false;
    }
  }

  // Fetches class standard list based on selected wing IDs.
  async getClassStandardList(wingIds: any) {
    this.loadingClassData = true;
    try {
      const body = {
        lang: "en",
        classCategoryIds: Array.isArray(wingIds) && wingIds.length > 0 ? wingIds : "All",
      };
      const response: any = await firstValueFrom(this.checkinCheckoutService.getClassStandardListData(body));
      if (response.status && response.body) {
        this.classStandardData = (response.body.classCategoryListData || []).map((c:any)=>({...c, isChecked: true}));
        this.selectedClassList = [...this.classStandardData];
        this.updateClassLabel();
        const classIds = this.classStandardData.map((c: any) => c.pkClassStandardsId);
        await this.getClassSectionList(classIds, wingIds);
      } else {
        this.classStandardData = [];
        this.selectedClassList = [];
        this.updateClassLabel();
      }
    } catch (error) {
      this.classStandardData = [];
      this.selectedClassList = [];
      this.updateClassLabel();
    } finally {
      this.loadingClassData = false;
    }
  }

  // Fetches class section list based on selected class and wing IDs.
  async getClassSectionList(classCategoryId: any, classStandardId: any) {
    this.loadingSectionData = true;
    this.fetchingSectionData = true;
    this.classSectionData = [];
    try {
      const body = {
        lang: "en",
        classStandardIds: Array.isArray(classCategoryId) && classCategoryId.length > 0
          ? classCategoryId
          : "All",
        classCategoryIds: Array.isArray(classStandardId) && classStandardId.length > 0
          ? classStandardId
          : "All",
      };
      const response: any = await firstValueFrom(
        this.checkinCheckoutService.getClassSectionDataInfo(body)
      );
      if (response.status && response.body) {
        this.classSectionData = (response.body.classSectionListData || []).map((s:any)=>({...s,displaySection:`${s.classStandardName} - ${s.classDivision}`, isChecked: true}));
        this.selectedSectionList = [...this.classSectionData];
        this.updateSectionLabel();
        if (this.classSectionData.length === 1) {
          this.selectedSectionList = [this.classSectionData[0]];
          this.updateSectionLabel();
          this.fetchStudentList();
        } else {
          this.studentList = [];
          this.filteredStudentList = [];
          this.selectedStudentList = [];
          this.updateStudentLabel();
        }
      }
    } catch (error) {
      this.classSectionData = [];
      this.fetchingSectionData = false;
      if (error?.error?.message) {
        customToastr(error.error.message, 'error');
      } else {
        const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong'));
        customToastr(somethingWentWrongTranslation, 'error');
      }
    } finally {
      this.loadingSectionData = false;
      this.fetchingSectionData = false;
    }
  }

  // Fetches student list based on selected section, class and wing IDs.
  async fetchStudentList() {
    this.loadingStudentData = true;
    if (this.selectedSectionList.length !== 1 || this.selectedClassList.length !== 1 || this.selectedWings.length !== 1) {
      this.studentList = [];
      this.filteredStudentList = [];
      this.selectedStudentList = [];
      this.updateStudentLabel();
      return;
    }
    try {
      const body: any = {
        lang: "en",
        academicId: this.academicId,
        classCategoryId: this.commonFunctionService.getSingleId(this.selectedWings, 'categoryId'),
        classStandardId: this.commonFunctionService.getSingleId(this.selectedClassList, 'pkClassStandardsId'),
        classId: this.commonFunctionService.getSingleId(this.selectedSectionList, 'classId')
      };
      const response: any = await firstValueFrom(
        this.checkinCheckoutService.getStudentListInfo(body)
      );
      if (response.status && response.body && response.body.studentList) {
        this.studentList = response.body.studentList;
        this.filteredStudentList = [...this.studentList];
        this.selectedStudentList = [];
        this.updateStudentLabel();
      } else{
        customToastr(response.message, 'error');
      }
    } catch (error) {
      let finalMessage = '';
      if (error?.error?.message) {
        customToastr(error.error.message, 'error');
      } else if (error?.message) {
        customToastr(error.message, 'error');
      } else {
         finalMessage = await firstValueFrom(
        this.translate.get('failedToFetchStudents')
      );
      }
      customToastr(error.error.message ||finalMessage,'error');
    } finally {
      this.loadingStudentData = false;
    }
  }

  // Updates wing selection status based on selected classes.
  updateWingCheckStatus() {
    this.wingListData = this.wingListData.map((wing: any) => {
      const wingClasses = this.selectedClassList.filter(
        (cls: any) => cls.categoryId === wing.categoryId
      );
      return {
        ...wing,
        isChecked: wingClasses.length > 0
      };
    });
    this.selectedWings = this.wingListData.filter((wing: any) => wing.isChecked);
    this.updateWingLabel();
  }

  // Updates class and section selection status based on selected sections.
  updateClassStatusCheckStatus() {
    this.classStandardData = this.classStandardData.map((cls: any) => ({
      ...cls,
      isChecked: this.selectedClassList.some(selectedCls =>
        selectedCls.pkClassStandardsId === cls.pkClassStandardsId
      )
    }));
    this.classSectionData = this.classSectionData.map((section: any) => ({
      ...section,
      isChecked: this.selectedSectionList.some(selectedSec =>
        selectedSec.classId === section.classId
      )
    }));
    this.updateWingCheckStatus();
    this.selectedClassList = this.classStandardData.filter((c: any) => c.isChecked);
    this.selectedSectionList = this.classSectionData.filter((s: any) => s.isChecked);
    this.updateClassLabel();
    this.updateSectionLabel();
  }

  // Updates section selection status based on selected classes and wings.
updateSectionCheckStatus() {
  this.classSectionData = this.classSectionData.map((section: any) => {
    const isClassSelected = this.selectedClassList.some(
      (cls: any) => cls.pkClassStandardsId === section.classStandardId
    );
    const isWingSelected = this.selectedWings.some(
      (wing: any) => wing.categoryId === section.categoryId
    );
    return { 
      ...section, 
      isChecked: isClassSelected && isWingSelected 
    };
  });
  this.selectedSectionList = this.classSectionData.filter(s => s.isChecked);
  this.updateSectionLabel();
}

// Fetches statistics based on applied filters.
  async getCheckinCheckoutStats() {
    this.isStatsLoading = true;
    try {

      const body = {
        lang: "en",
        academicId: this.academicId,
        classCategoryId: this.selectedWings.length === 0
          ? "All"
          : this.selectedWings.length === this.wingListData.length
            ? "All"
            : this.selectedWings.map((w: any) => w.categoryId),
        classStandardId:this.appliedSection !== 'All'
      ? [...new Set(this.appliedSection.map((s: any) => s.pkClassStandardsId))]
      : this.appliedClass === 'All'
        ? 'All'
        : this.appliedClass.map((c: any) => c.pkClassStandardsId),
        classId:
  this.appliedWing.length === 1 &&
  this.selectedClassList.length === 1 &&
  this.appliedSection.length === 1
    ? [this.appliedSection[0].classId]
    : this.appliedSection === 'All'
        ? 'All'
        : this.appliedSection.map((s: any) => s.classId),
        selectedDate: this.formatToApiDate(this.selected),
        studentList: this.getStudentIds(this.appliedStudentList, this.studentList),
        entryStatus: this.getEntryStatusFilter()
      };
      const response: any = await firstValueFrom(
        this.checkinCheckoutService.getCheckinCheckoutReport(body)
      );

      if (response.status && response.body) {
        this.stats = response.body.stats || [];
        this.statsMap = this.stats.reduce((acc: any, item: any) => {
          acc[item.statKey] = item.statValue;
          return acc;
        }, {});
        this.totalStudents=this.statsMap['Total Students'] || 0;
        this.totalRecords = response.body.stats[0]?.statValue || 0;
      }
    } catch (error) {
       const translatedError = await firstValueFrom(
      this.translate.get('faildToLoadStatistics')
    );
      customToastr(error.error.message || translatedError, 'error');
    }
    finally {
      this.isStatsLoading = false;
    }
  }

  // Fetches report data based on applied filters and pagination.
  async getCheckinCheckoutReportData(
  pageNumber: number = 1,
  pageLimit: number = 10
) {
  this.isReportLoading = true;
  try {
    const body = {
      lang: "en",
      academicId: this.academicId,

      classCategoryId: this.appliedWing === 'All'
        ? 'All'
        : this.appliedWing.map((w: any) => w.categoryId),
   classStandardId:this.appliedSection !== 'All'
      ? [...new Set(this.appliedSection.map((s: any) => s.pkClassStandardsId))]
      : this.appliedClass === 'All'
        ? 'All'
        : this.appliedClass.map((c: any) => c.pkClassStandardsId),

      classId:
  this.appliedWing.length === 1 &&
  this.selectedClassList.length === 1 &&
  this.selectedSectionList.length === 1
    ? [this.selectedSectionList[0].classId]
    : this.appliedSection === 'All'
        ? 'All'
        : this.appliedSection.map((s: any) => s.classId),

      selectedDate: this.formatToApiDate(this.selected),
      pageNumber,
      pageLimit,
      studentList: this.getStudentIds(this.appliedStudentList, this.studentList),
      entryStatus:
        !this.appliedEntryStatus || this.appliedEntryStatus === 'All'
          ? 'All'
          : [this.appliedEntryStatus],
    };
    const response: any = await firstValueFrom(
      this.checkinCheckoutService.getCheckinCheckoutReportData(body)
    );
    if (response.status && response.body) {
      if(this.reportColumns.length===0){
        this.reportColumns = response.body.reportColumnList || [];
      }
      this.reportData = response.body.reportStudentData ?? [];
      this.pageNumber = pageNumber;
      this.pageLimit = pageLimit;
      this.maxPageNumber = response.body.maxPageNumber ?? 1;
      this.totalRecords = this.maxPageNumber * pageLimit;
    }
    this.toggleSelectAllColumns(true);
  }  catch (error) {
    let errorMessage = error?.error?.message || error?.message;

    if (!errorMessage) {
      errorMessage = await firstValueFrom(
        this.translate.get('failedToFetchReportData')
      );
    }
    customToastr(error.error.message || errorMessage,'error');
  } finally {
    this.isReportLoading = false;
  }
}

// Returns report columns sorted by default column.
  get sortedReportColumns() {
    return [...this.reportColumns].sort((a, b) => {
      return b.isDefault - a.isDefault;
    });
  }

// Exports the report based on applied filters.
  async exportReport() {
    this.isExportingReport = true;
    try {
      const columnList = this.getExportColumnIds();
      const body: any = {
        lang: "en",
        academicId: this.academicId,
      classCategoryId: this.appliedWing === 'All'
        ? 'All'
        : this.appliedWing.map((w: any) => w.categoryId),

   classStandardId:this.appliedSection !== 'All'
      ? [...new Set(this.appliedSection.map((s: any) => s.pkClassStandardsId))]
      : this.appliedClass === 'All'
        ? 'All'
        : this.appliedClass.map((c: any) => c.pkClassStandardsId),

      classId:
  this.appliedWing.length === 1 &&
  this.selectedClassList.length === 1 &&
  this.selectedSectionList.length === 1
    ? [this.selectedSectionList[0].classId]
    : this.appliedSection === 'All'
        ? 'All'
        : this.appliedSection.map((s: any) => s.classId),

      selectedDate: this.formatToApiDate(this.selected),
        studentList: this.getStudentIds(this.appliedStudentList, this.studentList),
      entryStatus:
        !this.appliedEntryStatus || this.appliedEntryStatus === 'All'
          ? 'All'
          : [this.appliedEntryStatus],
        columnList: this.getExportColumnIds(),
      };
      const response: any = await firstValueFrom(
        this.checkinCheckoutService.getcheckinCheckoutExport(body)
      );
      if (response instanceof Blob) {
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `CheckinCheckoutReport_${this.startDate}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
       const successMsg = await firstValueFrom(this.translate.get('reportExportedSuccessfully'));
    customToastr(successMsg, "success");
    } catch (error) {
    let errorMessage = error?.error?.message || error?.message;

    if (!errorMessage) {
      errorMessage = await firstValueFrom(
        this.translate.get('failedtoexportreport')
      );
    }
    customToastr(error.error.message || errorMessage, 'error');
    } finally {
      this.isExportingReport = false;
      this.closeExportPopUp();
    }
  }

  // Opens the export report popup and selects all columns by default.
  openExportReportPopUp() {
    const allCols = this.reportColumns || [];
    this.selectedExportColumns = allCols.map((c: any) => c.pkReportColumnMapDetailId);
    $("#exportReport").modal("show");
  }

  // Closes the export report popup. 
  closeExportPopUp() {
    $("#exportReport").modal("hide");
  }

  // Handles individual column toggle for export selection.
 onExportColumnToggle(colId: number, checked: boolean) {
  if (checked && !this.selectedExportColumns.includes(colId)) {
    this.selectedExportColumns.push(colId);
  }
  if (!checked) {
    this.selectedExportColumns =
      this.selectedExportColumns.filter(id => id !== colId);
  }
}

// Handles select all/deselect all columns for export selection.
  toggleSelectAllColumns(checked: boolean) {
    const allCols = this.reportColumns || [];
    if (checked) {
      this.selectedExportColumns = allCols.map((c: any) => c.pkReportColumnMapDetailId);
    } else {
      this.selectedExportColumns = [];
    }
  }

  // Returns 'All' when all columns are selected, otherwise array of selected column IDs.
  getExportColumnIds(): number[] | string {
    const allIds = (this.reportColumns || []).map((c: any) => c.pkReportColumnMapDetailId);
    if (!this.selectedExportColumns?.length || this.selectedExportColumns.length === allIds.length) {
      return "All";
    }
    return this.selectedExportColumns;
  }

  // Disables the apply button if the report is loading.
  applyButtonDisabled(): boolean {
    return this.loadingClassData || this.loadingSectionData || this.isExportingReport || this.isReportLoading;
  }
}
